export const getDomainName = (url: string) => {
  const domainRegex = /^(https?:\/\/)?([^\\/\\?#]+)/i;
  const match = url.match(domainRegex);

  if (match && match[2]) {
    return match[2];
  }
  return null;
};
